import { defineAction } from "redux-define";
import {
    LOADING, ERROR, SUCCESS, FILTER, TheApp,
} from "../../constants/stateConstants";

export const mailbox = defineAction("mailbox", [LOADING, ERROR, SUCCESS], TheApp);
export const LIST = defineAction("LIST", [LOADING, ERROR, SUCCESS, FILTER], mailbox);
